import { getArchiveApps } from "@/api/archives";
import Vue from "vue";

const state = {
  list: [],
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
};

const actions = {
  async getApps({ commit }, payload) {
    try {
      const response = await getArchiveApps(payload);
      commit("SET_LIST", response);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
